import type { DistributionBrief } from "~/core/api/smart-distribution";

export function distributionPlanState(brief: DistributionBrief, now = Date.now()): string {
	if (brief.pending_plan || brief.state === "submitting") return "submitting";
	if (!brief.plan && !brief.jobs?.length) return brief.state;
	const states = brief.jobs?.map((job) => job.status?.state) ?? [];
	const complete = states.length === brief.plan?.items.length && states.length > 0;
	if (states.includes("running")) return "distributing";
	if (states.includes("waiting_human")) return "waiting_human";
	if (states.includes("unknown")) return "unknown";
	if (states.includes("queued")) {
		const queuedTimes =
			brief.plan?.items
				.filter((item) =>
					brief.jobs?.some((job) => job.platform_id === item.platform_id && job.status?.state === "queued"),
				)
				.map((item) => Date.parse(item.scheduled_at)) ?? [];
		return queuedTimes.length && queuedTimes.every((time) => time > now) ? "scheduled" : "queued";
	}
	if (!complete || states.some((state) => !state)) return "submitting";
	if (states.every((state) => state === "published")) return "distributed";
	if (states.includes("published")) return "partially_distributed";
	if (states.includes("failed")) return "failed";
	if (states.every((state) => state === "cancelled")) return "cancelled";
	if (states.includes("remote_draft")) return "remote_draft";
	return "unknown";
}

export function planSubmitted(brief: DistributionBrief | null): boolean {
	return !!brief && (!!brief.pending_plan || !!brief.plan || !!brief.jobs?.length);
}
